import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import SearchSVG from '../../assets/icons/magnifying-glass.svg';
import AccessibleHiddenText from '../AccessibleHiddenText';

interface SearchBoxProps {
  onSearch: (query: string) => void;
  label: string;
  id: string;
  placeholder?: string;
}

const SearchBoxContainer = styled.div(({ theme }) => {
  const { color } = theme.new;

  return `
    background-color: ${color.shade[1]};
    display: inline-block;
    align-items: center;
    box-shadow: 0px 2px 4px ${color.neutral[6]};
    border-radius: 1000px;
    padding: 8px 15px;
  `;
});

const SearchInput = styled.input`
  border: none;
  outline: none;
  padding: 4px;
`;

const SearchIcon = styled.img`
  display: inline-block;
  margin-right: 4px;
  margin-top: -2px;
`;

const SearchBox: React.FC<SearchBoxProps> = ({ onSearch, placeholder, label, id }) => {
  const [query, setQuery] = useState<string>('');
  const placeholderText = placeholder ? placeholder : 'Search...';

  const debounce = (callback: (query: string) => void, delay: number) => {
    let timeoutId: NodeJS.Timeout;
    return (input: string) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        callback(input);
      }, delay);
    };
  };

  const debouncedSearch = debounce(onSearch, 1000);

  useEffect(() => {
    debouncedSearch(query);
  }, [query, debouncedSearch]);

  return (
    <SearchBoxContainer>
      <AccessibleHiddenText>
        <label htmlFor={id}>{label}</label>
      </AccessibleHiddenText>
      <SearchIcon src={SearchSVG} />
      <SearchInput
        id={id}
        type="text"
        placeholder={placeholderText}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
    </SearchBoxContainer>
  );
};

export default SearchBox;
